import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthUp, WithWidth } from '@material-ui/core/withWidth';
import { CompanySearch } from './CompanySearch';
import { WithStyles, withStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

export const styles = {
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12
  }
};

export type OwnProps = {
  title?: string;
  toggleDrawer: () => void;
  includeCompanySearch: boolean;
};

export type Props = WithWidth & WithStyles<typeof styles> & OwnProps;

const MobileAppBarComponent: React.FC<Props> = ({ title, classes, width, toggleDrawer, includeCompanySearch }) => {
  const { t } = useTranslation();
  return (
    <AppBar position="fixed">
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label={t('components.mobileAppBar.openDrawer', 'open drawer')}
          onClick={toggleDrawer}
          className={classes.menuButton}
        >
          <MenuIcon />
        </IconButton>
        {(!includeCompanySearch || isWidthUp('sm', width)) && (
          <Typography variant="h6" color="inherit" className={classes.grow} align="center">
            {title}
          </Typography>
        )}
        {includeCompanySearch && <CompanySearch />}
      </Toolbar>
    </AppBar>
  );
};

export const MobileAppBar = withWidth()(withStyles(styles)(MobileAppBarComponent));
